import React, { useEffect } from 'react';
import { FaStar, FaTimes, FaHeart, FaRegHeart, FaCalendarAlt, FaClock, FaFilm, FaUserFriends, FaPen, FaAward, FaGlobe, FaLanguage } from 'react-icons/fa';

const MovieDetail = ({ movie, onClose, isFavorite, onToggleFavorite }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const handleEsc = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handleEsc);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleEsc);
    };
  }, [onClose]);

  if (!movie) return null;

  const posterUrl = movie.Poster !== 'N/A'
    ? movie.Poster
    : 'https://via.placeholder.com/300x450/1a1a3e/6a6a8e?text=No+Poster';

  const formatDetail = (detail) => detail === 'N/A' ? 'Not available' : detail;

  const genres = movie.Genre && movie.Genre !== 'N/A'
    ? movie.Genre.split(',').map(g => g.trim())
    : [];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content-custom" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <FaTimes />
        </button>

        {/* Poster */}
        <div className="modal-poster-section">
          <img src={posterUrl} alt={movie.Title} />
        </div>

        {/* Details */}
        <div className="modal-details">
          <div className="modal-title">{movie.Title}</div>

          {/* Badges */}
          <div className="modal-badges">
            <span className="modal-badge">
              <FaCalendarAlt className="badge-icon" /> {movie.Year}
            </span>
            {movie.Rated !== 'N/A' && (
              <span className="modal-badge">{movie.Rated}</span>
            )}
            {movie.Runtime !== 'N/A' && (
              <span className="modal-badge">
                <FaClock className="badge-icon" /> {movie.Runtime}
              </span>
            )}
          </div>

          {/* Genre Tags */}
          {genres.length > 0 && (
            <div className="genre-tags">
              {genres.map((genre) => (
                <span key={genre} className="genre-tag">{genre}</span>
              ))}
            </div>
          )}

          {/* Favorite Button */}
          <button
            className={`modal-fav-btn ${isFavorite ? 'is-fav' : ''}`}
            onClick={() => onToggleFavorite(movie)}
            style={{ marginBottom: '1.5rem' }}
          >
            {isFavorite ? <FaHeart /> : <FaRegHeart />}
            {isFavorite ? 'In Your Collection' : 'Add to Collection'}
          </button>

          {/* IMDb Rating */}
          {movie.imdbRating !== 'N/A' && (
            <div className="imdb-rating-box">
              <div>
                <span className="imdb-rating-score">{movie.imdbRating}</span>
                <span className="imdb-rating-max"> /10</span>
              </div>
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                  <FaStar className="imdb-star" />
                  <span style={{ fontWeight: 600, color: 'var(--text-primary)', fontSize: '0.9rem' }}>IMDb Rating</span>
                </div>
                <div className="imdb-rating-votes">{movie.imdbVotes} votes</div>
              </div>
            </div>
          )}

          {/* Plot */}
          <div className="modal-section">
            <div className="modal-section-title">Plot</div>
            <div className="modal-section-text">{formatDetail(movie.Plot)}</div>
          </div>

          {/* Info Grid */}
          <div className="modal-info-grid">
            <div className="modal-info-card">
              <div className="modal-info-label">
                <FaUserFriends className="info-icon" /> Director
              </div>
              <div className="modal-info-value">{formatDetail(movie.Director)}</div>
            </div>
            <div className="modal-info-card">
              <div className="modal-info-label">
                <FaPen className="info-icon" /> Writer
              </div>
              <div className="modal-info-value">{formatDetail(movie.Writer)}</div>
            </div>
            <div className="modal-info-card">
              <div className="modal-info-label">
                <FaUserFriends className="info-icon" /> Cast
              </div>
              <div className="modal-info-value">{formatDetail(movie.Actors)}</div>
            </div>
            <div className="modal-info-card">
              <div className="modal-info-label">
                <FaFilm className="info-icon" /> Genre
              </div>
              <div className="modal-info-value">{formatDetail(movie.Genre)}</div>
            </div>
          </div>

          {/* Awards */}
          {movie.Awards !== 'N/A' && (
            <div className="modal-awards">
              <FaAward className="award-icon" />
              <div>
                <div style={{ fontWeight: 700, color: 'var(--accent-cyan)', fontSize: '0.85rem', marginBottom: 4 }}>Awards</div>
                <div className="award-text">{movie.Awards}</div>
              </div>
            </div>
          )}

          {/* Metadata */}
          <div className="modal-meta">
            <div className="modal-meta-item">
              <FaGlobe style={{ marginRight: 6, color: 'var(--text-muted)' }} />
              Country: <span>{formatDetail(movie.Country)}</span>
            </div>
            <div className="modal-meta-item">
              <FaLanguage style={{ marginRight: 6, color: 'var(--text-muted)' }} />
              Language: <span>{formatDetail(movie.Language)}</span>
            </div>
            <div className="modal-meta-item">
              <FaCalendarAlt style={{ marginRight: 6, color: 'var(--text-muted)' }} />
              Released: <span>{formatDetail(movie.Released)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MovieDetail;
